// extracted by mini-css-extract-plugin
export var container = "BenefitsItem-module--container--WMsE7";